import { useLazyQuery } from '@apollo/client';
import { useMemo } from 'react';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { ALL_ITEMS } from '@/config/common.config';
import GetPaginatedFilteredVariableContractLinesQuery from
  '@/graphql/contracts/getPaginatedFilteredVariableContractLines.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { GetPaginatedFilteredVariableContractLines, GetPaginatedFilteredVariableContractLinesVariables } from
  '@/graphql/contracts/_generated_/getPaginatedFilteredVariableContractLines.query';
import { VariableContractLineFilterInput } from '@/graphql/contracts/_generated_/contracts';


export default function useGetVariableContractLines() {
  const [_getVariableContractLines, { loading, error, data }] =
    useLazyQuery<GetPaginatedFilteredVariableContractLines, GetPaginatedFilteredVariableContractLinesVariables>(
      GetPaginatedFilteredVariableContractLinesQuery, {
        client: apolloClientContracts,
        fetchPolicy: 'network-only',
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        }),
      });

  const getVariableContractLines = (dto: VariableContractLineFilterInput) => {
    _getVariableContractLines({
      variables: {
        filter: dto,
        first: ALL_ITEMS
      }
    });
  };

  return useMemo(() => ({
    getVariableContractLines,
    isLoadingVariableContractLines: loading,
    errorVariableContractLines: error,
    variableContractLines: data?.paginatedFilteredVariableContractLines?.items ?? []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [loading, error, data]);
}
